<template>
  <div class="basicStyle"> 
    <div class="bg_box">
      <el-card class="box-card">
        <el-form
          :model="queryForm"
          label-width="0"
          :loading="isLoading"
        >
          <div class="title">
            ▪ 定制信息 <el-button type="primary" :loading="loading" style="margin-left: 50px;" @click="getAddress">快速填充</el-button>
          </div>

          <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>省份单招类别：</label>
            <el-form-item class="inline-form-item">
              <el-select
                v-model="queryForm.dzs_cate_pid"
                placeholder="请选择单招类别"
                filterable
                clearable
                style="width: 300px"
                @change="dzsCatePid"
              >
                <el-option
                  v-for="item in customizedResOptions"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </div>

          <div v-if="queryForm.custom_mode == 2 && dzsCateMode2Options.length" class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>考试类：</label>
            <el-form-item class="inline-form-item">
              <el-select
                v-model="queryForm.dzs_cate_id"
                placeholder="请选择考生类别"
                filterable
                clearable
                style="width: 300px"
                @change="dzsCateMode2"
              >
                <el-option
                  v-for="item in dzsCateMode2Options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>

          <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>考生姓名：</label>
            <el-form-item class="inline-form-item">
              <el-input
                v-model="queryForm.name"
                class="filter-input"
                clearable
                placeholder="请输入考生姓名"
                style="width: 300px"
              />
            </el-form-item>
          </div>
          <div v-if="queryForm.custom_mode == 1" class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>考生类别：</label>
            <el-form-item class="inline-form-item">
              <el-select
                v-model="queryForm.attr_id"
                placeholder="请选择考生类别"
                filterable
                clearable
                style="width: 300px"
                @change="attrChange"
              >
                <el-option
                  v-for="item in attrOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </div>
          <div v-if="queryForm.custom_mode == 1" class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>报考院校：</label>
            <el-form-item class="inline-form-item">
              <el-select
                v-model="queryForm.college_id"
                placeholder="请选择报考院校"
                filterable
                clearable
                style="width: 300px"
                @change="collegeChange"
              >
                <el-option
                  v-for="college in collegeOptions"
                  :key="college.id"
                  :label="college.title"
                  :value="college.id.toString()"
                />
              </el-select>
            </el-form-item>
          </div>
          <div v-if="queryForm.custom_mode == 1" class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>报考专业：</label>
            <el-form-item class="inline-form-item">
              <div v-if="queryForm.major_name" style="display: inline-block;">{{ queryForm.major_name }}</div>
              <el-input
                v-else
                v-model="queryForm.major_name"
                class="filter-input"
                clearable
                placeholder="请选择报考专业"
                style="width: 250px;background: #F7F8FB;"
                disabled
              />
              <el-button type="primary" @click="majorChoose">
                <span v-if="queryForm.major_name">重新选择</span>
                <span v-else>选择</span>
              </el-button>
            </el-form-item>
          </div>
          <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>资料类别：</label>
            <el-form-item class="inline-form-item">
              <el-radio-group v-model="queryForm.type" @change="$forceUpdate()">
                <el-radio
                  v-for="(item, index) in customizedResMatchGoodsOptions"
                  :key="index"
                  :label="item.value"
                  border
                >
                  {{ item.flag }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>选择科目：</label>
            <el-form-item v-if="subjectList.length > 0" class="inline-form-item">
              <el-checkbox-group v-model="selectSubjects" @change="$forceUpdate()">
                <el-checkbox
                  v-for="(item, index) in subjectList"
                  :key="index"
                  :label="item.examoutline_id"
                  border
                >{{ item.subject_name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item v-else>
              请先选择报考院校和专业
            </el-form-item>
          </div>
          <div class="title">
            ▪ 收件信息
          </div>
          <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>收件人姓名：</label>
            <el-form-item class="inline-form-item">
              <el-input
                v-model="queryForm.address_name"
                class="filter-input"
                clearable
                placeholder="请输入收件人姓名"
                style="width: 300px"
              />
            </el-form-item>
          </div>
          <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>手机号：</label>
            <el-form-item class="inline-form-item">
              <el-input
                v-model="queryForm.address_phone"
                class="filter-input"
                clearable
                placeholder="请输入手机号"
                style="width: 300px"
                maxlength="11"
                show-word-limit
                @change="addressPhoneChange"
              />
            </el-form-item>
          </div>
          <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>收件地址：</label>
            <el-form-item class="inline-form-item">
              <el-cascader
                v-model="area"
                :options="areaRawData"
                :props="{
                  expandTrigger: 'hover',
                  value: 'id',
                  label: 'label',
                  children: 'children',
                }"
                placeholder="请选择收件地址"
                style="width: 300px"
                @change="handleChange"
              />

              <el-input
                v-model="queryForm.address"
                class="filter-input"
                clearable
                placeholder="详细街道地址"
                style="width: 300px;display: block;margin-top: 10px;"
              />
            </el-form-item>

          </div>

          <div class="title">
            ▪ 基本信息
          </div>
          <!-- <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>订单来源：</label>
            <el-form-item class="inline-form-item">
              <el-radio-group v-model="queryForm.order_from">
                <el-radio
                  v-for="(item, index) in orderFromOptions"
                  :key="index"
                  :label="item.key"
                >
                  {{ item.value }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </div> -->
          <div class="filter-item ml-3">
            <label class="classLabel"><span class="star">*</span>用户手机号：</label>
            <el-form-item class="inline-form-item">
              <el-input
                v-model="queryForm.mobile"
                class="filter-input"
                clearable
                placeholder="请输入用户手机号"
                style="width: 200px"
                maxlength="11"
                show-word-limit
                @input="$forceUpdate()"
                @change="mobileChange"
              />
              <div v-if="queryForm.mobile&&uid" class="userProfile">
                当前手机号已在产品内注册
                <el-button type="text" @click="clickToView">点击查看用户档案></el-button>
              </div>
              <!-- <div v-else-if="queryForm.mobile&&!uid" class="userProfile">
                当前手机号未注册
              </div> -->
            </el-form-item>
          </div>
          <div style="margin-top: 20px;margin-left:150px;">
            <el-button type="primary" :loading="saveLoading" @click="confirm()">确认保存</el-button>
          </div>
        </el-form>
      </el-card>

      <el-dialog
        :title="dialogTitle"
        :visible.sync="majorVisible"
        width="80%"
        :before-close="handleClose"
      >
        <el-card class="box-card">
          <el-form :inline="true" :model="searchFormObj" class="demo-form-inline">
            <el-form-item label="招生年份：" class="inline-form-item">
              <el-select
                v-model="searchFormObj.year"
                placeholder="请选择"
                filterable
              >
                <el-option label="不限" value="0" />
                <el-option
                  v-for="item in yearOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="招生省份：" class="inline-form-item">
              <el-select
                v-model="searchFormObj.province_id"
                filterable
                placeholder="请选择招生省份"
                @change="provinceChange"
              >
                <el-option
                  v-for="item in regionOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="searchFormObj.province_id > 0 && attrOptions2.length > 0"
              label="单招类别："
              class="inline-form-item"
            >
              <el-select
                v-model="searchFormObj.dzs_cate_id"
                filterable
                placeholder="请选择单招类别"
                clearable
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="item in attrOptions2"
                  :key="item.id.toString()"
                  :label="item.name"
                  :value="item.id.toString()"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="考生类别：" class="inline-form-item">
              <el-select
                v-model="attr_id"
                multiple
                collapse-tags
                placeholder="请选择考生类别"
                clearable
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="item in enrollTypeOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="状态：" class="inline-form-item">
              <el-select
                v-model="searchFormObj.status"
                placeholder="请选择"
                filterable
                @change="$forceUpdate()"
              >
                <el-option label="不限" value="-1" />
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="院校ID/名称：" class="inline-form-item">
              <el-input
                v-model="searchFormObj.college_id"
                clearable
                placeholder="输入查询"
                style="width: 300px"
                @keyup.enter.native="onSearchSubmit"
                @input="$forceUpdate()"
              />
            </el-form-item>
            <el-form-item label="专业组：" class="inline-form-item">
              <el-input
                v-model="searchFormObj.major_group"
                clearable
                placeholder="输入查询"
                style="width: 300px"
                @keyup.enter.native="onSearchSubmit"
                @input="$forceUpdate()"
              />
            </el-form-item>
            <el-form-item label="专业ID/名称：" class="inline-form-item">
              <el-input
                v-model="searchFormObj.major_id"
                clearable
                placeholder="输入查询"
                style="width: 300px"
                @keyup.enter.native="onSearchSubmit"
                @input="$forceUpdate()"
              />
            </el-form-item>
            <el-form-item label="记录ID：" class="inline-form-item">
              <el-input
                v-model="searchFormObj.id"
                clearable
                placeholder="输入查询"
                style="width: 300px"
                @keyup.enter.native="onSearchSubmit"
                @input="$forceUpdate()"
              />
            </el-form-item>
            <el-form-item label="录入时间：" class="inline-form-item">
              <el-date-picker
                v-model="timeArr"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item class="inline-form-item">
              <el-button type="primary" icon="el-icon-search" @click="onSearchSubmit">查询</el-button>
            </el-form-item>
            <el-form-item class="inline-form-item">
              <el-button type="warning" icon="el-icon-refresh" @click="onSearchEmptySubmit">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <div class="table_box">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="max-height: 55vh; overflow-y: scroll; width: 100%; margin-top: 10px;"
            stripe
            border
          >
            <el-table-column align="center" width="100">
              <template slot="header">
                <h4 style="margin:0;line-height:120%;color:#333;">
                  记录ID
                </h4>
              </template>
              <template slot-scope="scope">
                {{ scope.row.id }}
              </template>
            </el-table-column>
            <el-table-column align="center" width="120">
              <template slot="header">
                <h4 style="margin:0 0 2px 0;line-height:120%;color:#333;">
                  【院校ID】院校名称
                </h4>
                <div style="margin:0;line-height:120%;">（必填）</div>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.college">
                  <span
                    v-if="scope.row.college.id"
                  >【{{ scope.row.college.id }}】</span>
                  {{ scope.row.college.title }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <h4 style="margin:0 0 2px 0;line-height:120%;color:#333;">
                  招生年份
                </h4>
                <div style="margin:0;line-height:120%;">（必填）</div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.year }}
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <h4 style="margin:0 0 2px 0;line-height:120%;color:#333;">
                  招生省份
                </h4>
                <div style="margin:0;line-height:120%;">（必填）</div>
              </template>
              <template slot-scope="scope">
                {{ provinceMap.get(scope.row.province_id) }}
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <h4 style="margin:0 0 2px 0;line-height:120%;color:#333;">
                  单招类别
                </h4>
                <div style="margin:0;line-height:120%;">（必填）</div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.category }}
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <h4 style="margin:0 0 2px 0;line-height:120%;color:#333;">
                  关联招生类别
                </h4>
                <div style="margin:0;line-height:120%;">（必填）</div>
              </template>
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.attrs" :key="index">
                  <i v-if="index != 0">,</i>
                  {{ enrollTypeMap.get(item.attr_id.toString()) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="120">
              <template slot="header">
                <h4 style="margin:0 0 2px 0;line-height:120%;color:#333;">
                  【专业ID】专业名称
                </h4>
                <div style="margin:0;line-height:120%;">（必填）</div>
              </template>
              <template slot-scope="scope">
                <span
                  v-if="scope.row.major && scope.row.major.id"
                >【{{ scope.row.major.id }}】</span>
                <span v-if="scope.row.major && scope.row.major.title">{{
                  scope.row.major.title
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <h4 style="margin:0 0 2px 0;line-height:120%;color:#333;">
                  细分方向说明
                </h4>
                <div style="margin:0;line-height:120%;">（非必填）</div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.directation_description }}
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <h4 style="margin:0 0 2px 0;line-height:120%;color:#333;">
                  专业组
                </h4>
                <div style="margin:0;line-height:120%;">（非必填）</div>
              </template>
              <template slot-scope="scope">
                {{ scope.row.major_group }}
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  @click="majorFn(scope.row)"
                >选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box">
          <el-pagination
            :current-page="searchFormObj.page"
            background
            :page-sizes="[10, 20, 30, 50]"
            :page-size="searchFormObj.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-dialog>

      <!-- 快速填充对话框 -->
      <el-dialog
        title="快速填充信息"
        :visible.sync="addressQuickFillVisible"
        width="800px"
        :before-close="handleAddressQuickFillClose"
      >
        <el-form :inline="true" :model="addressQuickFillForm" class="demo-form-inline">
          <el-form-item label="粘贴内容：" class="inline-form-item">
            <el-input
              v-model="addressQuickFillForm.content"
              type="textarea"
              rows="10"
              placeholder="请粘贴包含收件人姓名、手机号和地址等信息的内容"
              style="width: 300%"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleAddressQuickFillClose">取消</el-button>
          <el-button type="primary" :loading="loading" @click="confirmAddressQuickFill">确认填充</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="doubleConfirmVisible"
        width="500px"
        :before-close="handleClose"
      >
        <div class="doubleTitle">
          请确认好相关填写信息，一旦提交，将不可二次更改，也无法申请退款 
        </div>
        <div class="doubleCont">
          {{ goodInfo.good_name }} 
        </div>
        <div class="doubleCont">
          {{ goodInfo.cb_price_total }}元 
        </div> 
        <div slot="footer" class="dialog-footer">
          <el-button @click="doubleConfirmVisible = false">取消</el-button>
          <el-button type="primary" :loading="loading" @click="saveFn()">提交</el-button>
        </div>
      </el-dialog> 
      <el-dialog
        title=""
        :visible.sync="successVisible"
        width="500px"
        :before-close="handleClose"
      >
        <div class="" v-if="submissionType">
          <div class="successTitle">
            定制成功，已扣除金额
          </div>
          <div class="successCont1">
            {{ goodInfo.cb_price_total }}元 
          </div>
        </div>
        <div v-else>
          <div class="successCont2">
            账户余额不足，请充值
          </div>
          <div v-if="czbtnShow" class="successCont3">
            <el-button @click="rechargeBtn()">充值</el-button> 
          </div>
        </div>
      
      </el-dialog>  
      <el-dialog
        title=""
        :visible.sync="rechargeVisible"
        width="500px"
        :before-close="handleClose"
      >
        <div class="RechargeBox">
          <div class="rightH2Top">
            <div class="rightH2a">
              <img
                class="topLeft"
                src="../../../assets/new/tj_a5.png"
                alt=""
                style="
                  vertical-align: middle;
                  width: 20px;
                  height: 20px;
                  margin-top: -3px;
                  margin-right: 10px;
                "
              />
              技术对接和充值:
              {{ contacts }}
            </div>
            <div class="rightH2a">
              <img
                class="topLeft"
                src="../../../assets/new/tj_a4.png"
                alt=""
                style="
                  vertical-align: middle;
                  width: 20px;
                  height: 20px;
                  margin-top: -3px;
                  margin-right: 10px;
                "
              />
              联系方式：
              {{ contacts_moblie }}
            </div>
          </div>
          <div class="rightH2Bottom">
            <div class="rightH2b">
              <img
                class="img"
                :src="quickresponse"
                alt=""
                style="width: 100%; height: 100%; margin-bottom: 7px"
              />
              <div>微信咨询 扫码联系</div>
            </div>
          </div>
        </div>
      </el-dialog> 
    </div> 
  </div>
</template>

<script> 
import commonApi from "@/api/common.js";
import studentApi from '@/api/student.js';
import PublicOptions from "@/utils/publicOptions";
import { deepClone } from "@/utils/index.js";
export default {
  name: "CustomOrderAdd",
  data() {
    const searchForm = {
      province_id: '5604',
      dzs_cate_id: '7079',
      year: '0',
      status: 1,
      is_update: '-1',
      limit: 10,
      page: 1
    }
    return { 
       queryForm: {
        name: '',
        attr_id: '',
        college_id: '',
        major_name: '',
        major_id: '',
        plan_id: '',
        type: '1,2',
        order_from: '5',
        address_name: '',
        address_phone: '',
        address: '', 
        mobile: '',
        custom_mode: 1,
        dzs_cate_pid: "7079"
      },
      isLoading: false,
      collegeOptions: [],
      typeOptions: [ // 资料类别 1-考点习题集 2-练习卷 多个逗号
        { value: '1', label: '考点习题集' },
        { value: '2', label: '练习卷' }
      ],
      subjectList: [],
      selectSubjects: [], // 选择的科目
      area: [],
      areaRawData: [],
      majorVisible: false,
      orderFromOptions: [
        {
          flag: "1",
          key: "3",
          sort: "3",
          value:"备考通B端"
        }
      ],
      dialogTitle: '报考专业选择',
      searchFormObj: { ...searchForm },
      searchDefaultFormObj: { ...searchForm },
      tableData: [],
      total: 0,
      yearOptions: PublicOptions.yearOptions,
      regionOptions: [],
      attrOptions: [],
      attrOptions2: [],
      statusOptions: [
        // 1启用0禁用
        { value: 1, label: '显示' },
        { value: 0, label: '隐藏' }
      ],
      enrollTypeOptions: [],
      attr_id: [],
      timeArr: [],
      saveLoading: false,
      allAreaData: [],
      uid: '',
      customizedResMatchGoodsOptions: [
        {
          value:"1,2",
          flag:"习题集+练习卷组合",
          sort: 1,
          key: '251'
        }
      ],
      // 快速填充相关
      addressQuickFillVisible: false,
      addressQuickFillForm: {
        content: ''
      },
      loading: false,
      customizedResOptions: [],
      dzsCateMode2Options: [],
      goodInfo: {},
      good_id: "",
      doubleConfirmVisible: false, 
      rechargeVisible: false,
      tob_good_id: '',
      contacts: "",
      contacts_moblie: "",
      quickresponse: "",
      successVisible: false,
      submissionType: false, 
      czbtnShow: false,
      status:"" 
    };
  },
  created() { 
    if(this.$route.query.tob_order_from){
      this.queryForm.order_from = this.$route.query.tob_order_from
    } 
    if (this.$route.query.good_id) {
      this.good_id = this.$route.query.good_id; 
    } 
    if (this.$route.query.tob_good_id) {
      this.tob_good_id = this.$route.query.tob_good_id; 
    }       

    this.contacts = localStorage.getItem("contacts")
    this.contacts_moblie = localStorage.getItem("contacts_moblie")
    this.quickresponse = localStorage.getItem("quickresponse")
  
    this.getDictionaryData()
    this.getCollegeList()
    this.getAreaList()
    this.getAreas()
    // this.getDzsCateMode2()
    
    this.provinceChange(this.searchFormObj.province_id) 
  }, 
  computed: { 
    provinceMap() {
      return new Map(this.regionOptions.map(item => [item.id, item.name]))
    },
    enrollTypeMap() {
      return new Map(
        this.enrollTypeOptions.map(item => [item.key, item.value])
      )
    },
    allAreaMap() {
      return new Map(this.allAreaData.map(item => [item.id, item.name]))
    }
  },
  methods: {
    attrChange(e){
      if(e){ 
        this.queryForm.major_id = ''
        this.queryForm.plan_id = ''
        this.queryForm.major_name = ''
        this.subjectList = []
      }
    },
    collegeChange(e){
      if(e){
        this.queryForm.major_id = ''
        this.queryForm.plan_id = ''  
        this.queryForm.major_name = ''
        this.subjectList = []
      }
    },

    rechargeBtn(){
      this.successVisible = false
      this.rechargeVisible = true
    }, 
    // 获取字典数据
    getDictionaryData() {
      const params = {
        names: 'senioriupEnrollType,hnxxdanzhaoOrderOrigin,customizedResMatchGoods,customizedResType'
      }
      commonApi.getDictionaries(params).then(res => {
        if (res.code === 200) {
          this.attrOptionsAll = res.data.senioriupEnrollType
          // this.orderFromOptions = res.data.hnxxdanzhaoOrderOrigin
          this.enrollTypeOptions = res.data.senioriupEnrollType
          // this.customizedResMatchGoodsOptions = res.data.customizedResMatchGoods
          res.data.customizedResType.forEach(item => {
            item.label = item.flag + '(模式' + item.value + ')'
            this.customizedResOptions.push(item)
          })
 
          this.dzsCatePid('7079')
        }
      })
    },
    dzsCatePid(e) {
      this.customizedResOptions.forEach(item => {
        if (item.key == e) {
          this.queryForm.custom_mode = item.value
        }
      }) 
      this.queryForm.dzs_cate_id = ''
      this.queryForm.attr_id = ''
      this.dzsCateMode2Options = []
      this.subjectList = []
      if (e == '7080') {
        this.attrOptions = [
          {
            key: '1',
            value: '普高生'
          },
          {
            key: '2',
            value: '三校生'
          }
        ]
      } else {
        this.attrOptions = this.attrOptionsAll
      } 
      this.getDzsCateMode2(e, this.queryForm.custom_mode)
    },
    getDzsCateMode2(dzs_cate_pid, type) {
      commonApi.getDzsCateMode2({
        id: dzs_cate_pid,
        type: type
      })
        .then(res => {
          if (res.code == 200) {
            console.log('getDzsCateMode2', res.data)
            this.searchFormObj.province_id = ''
            this.searchFormObj.dzs_cate_id = ''
            if (res.data && res.data.length > 0) {
              this.searchFormObj.province_id = res.data[0].province_id
              this.provinceChange(this.searchFormObj.province_id)
              this.searchFormObj.dzs_cate_id = res.data[0].id.toString()
              this.dzsCateMode2Options = res.data
            } else {
              this.getExamoutlineSubjectMode2(dzs_cate_pid)
            }
          }
        })
    },
    dzsCateMode2(dzs_cate_id) {
      this.getExamoutlineSubjectMode2(dzs_cate_id)
    },
    getExamoutlineSubjectMode2(dzs_cate_id) {
      commonApi.getExamoutlineSubjectMode2({
        dzs_cate_id: dzs_cate_id
      })
        .then(res => {
          if (res.code == 200) { 
            this.selectSubjects = []
            if(res.data && res.data.length > 0){ 
              this.subjectList = res.data
              this.selectSubjects.push(res.data[0].examoutline_id) 
            } 
          }
        })
    },
    clickToView() {
      console.log('clickToView---', this.queryForm) 
      const routeData = this.$router.resolve({
        path: '/studentManage',
        query: {
          mobile: this.queryForm.mobile, 
          status: this.status
        }
      })
      window.open(routeData.href, '_blank')
    },
    mobileChange(e) {
      console.log('mobileChange', e)
      if (e) {
        this.queryForm.mobile = e
        if (this.queryForm.mobile.length === 11) {
          this.getUserinfo()
        }
      }
      this.$forceUpdate()
    },
    addressPhoneChange(e) {
      if (e) {
        this.queryForm.mobile = e
        if (this.queryForm.mobile.length === 11) {
          this.getUserinfo()
        }
      }
      this.$forceUpdate()
    },
    getUserinfo() {
      console.log('getUserinfo', this.queryForm.mobile)
      studentApi.studentsList({ 
        keyword: this.queryForm.mobile, 
        status: 1, 
      })
        .then(res => {
          if (res.code === 200) {
            this.uid = ''
            if (res.data && res.data.data && res.data.data[0].uid) { 
              this.uid = res.data.data[0].uid 
              this.status = res.data.data[0].status
            }
            console.log('111', this.uid)
          }
        })
    },
    // 专业选择
    majorFn(e) {
      console.log('majorFn---', e)
      if (e.directation_description) {
        this.queryForm.major_name = e.name + '：' + e.directation_description
      } else {
        this.queryForm.major_name = e.name
      }
      this.queryForm.major_id = e.major_id
      this.queryForm.plan_id = e.id
      this.getCollectSubjects()
      this.getQuestionEdusPlan()
      this.majorVisible = false
    },
    // 获取这个计划的科目列表
    getCollectSubjects() {
      if (!this.queryForm.attr_id && this.queryForm.custom_mode == 1) {
        this.$message.error('请先选择考生类别!')
        return
      }
      if (!this.queryForm.plan_id && this.queryForm.custom_mode == 1) {
        this.$message.error('请先选择报考专业!')
        return
      }
      this.subjectList = []
      commonApi.getExamOutLintSubjects({ attr_id: this.queryForm.attr_id, plan_id: this.queryForm.plan_id }).then(res => {
        if (res.code === 200) {
          this.selectSubjects = []
          if (res.data && res.data.length > 0) {   
            this.subjectList = res.data
            this.selectSubjects.push(res.data[0].examoutline_id)  
          } else {
            this.$message.error('科目为空，请选择其他报考专业')
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 查询
    onSearchSubmit() {
      this.searchFormObj.page = 1
      this.getQuestionEdusPlan()
    },
    onSearchEmptySubmit() {
      this.timeArr = []
      this.attr_id = []
      this.searchFormObj = { ...this.searchDefaultFormObj }
      this.searchFormObj.page = 1
      this.getQuestionEdusPlan()
    },
    handleCurrentChange(val) {
      this.searchFormObj.page = val
      this.getQuestionEdusPlan()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.searchFormObj.limit = val
      this.searchFormObj.page = 1
      this.getQuestionEdusPlan()
    },
    getQuestionEdusPlan() {
      this.pageLoading = true
      var query = deepClone(this.searchFormObj)
      if (this.timeArr && this.timeArr.length == 2) {
        query.start_at = this.timeArr[0]
        query.end_at = this.timeArr[1]
      }
      query.attr_id = this.attr_id.toString()
      commonApi.getQuestionEdusPlan(query)
        .then(res => {
          this.pageLoading = false
          if (res.code == 200) {
            res.data.data.forEach(item => {
              item.name = item.major.title
            })
            this.tableData = res.data.data
            this.total = res.data.total
          }
        })
        .catch(() => {
          this.pageLoading = false
        })
    },
    // 搜索专业，获取对应的数据
    searchMajor(majorName, isFillFromParsed = false) {
      console.log('开始搜索专业:', majorName)
      console.log('当前已填充的院校ID:', this.queryForm.college_id)
      console.log('是否来自解析填充:', isFillFromParsed)

      const searchWithCollege = () => {
        const searchParams = {
          province_id: this.searchFormObj.province_id || 5604,
          dzs_cate_id: this.searchFormObj.dzs_cate_id || 7079,
          major_id: majorName,
          college_id: this.queryForm.college_id,
          limit: 10,
          page: 1
        }

        console.log('使用院校ID筛选专业:', this.queryForm.college_id)
        this.pageLoading = true
        commonApi.getQuestionEdusPlan(searchParams)
          .then(res => {
            this.pageLoading = false
            if (res.code == 200 && res.data.data.length > 0) {
              console.log('专业搜索结果:', res.data.data)

              let matchedMajor = null
              for (const item of res.data.data) {
                item.name = item.major.title
                if (item.name === majorName || item.name.includes(majorName) || majorName.includes(item.name)) {
                  matchedMajor = item
                  break
                }
              }

              if (!matchedMajor && res.data.data.length > 0) {
                matchedMajor = res.data.data[0]
                console.log('未找到精确匹配，使用第一个结果:', matchedMajor)
              }

              if (matchedMajor) {
                this.queryForm.major_id = matchedMajor.major_id
                this.queryForm.plan_id = matchedMajor.id
                console.log('专业数据已更新到表单:', {
                  major_id: matchedMajor.major_id,
                  plan_id: matchedMajor.id,
                  college_id: matchedMajor.college_id
                })
                this.getCollectSubjects()
              } else {
                if (isFillFromParsed) {
                  this.queryForm.major_name = ''
                  this.queryForm.major_id = ''
                  this.queryForm.plan_id = ''
                  console.log('学校没有该专业，已清除专业填充')
                } else {
                  console.log('使用院校ID未找到匹配专业，退回到无院校ID搜索')
                  searchWithoutCollege()
                }
              }
            } else {
              if (isFillFromParsed) {
                this.queryForm.major_name = ''
                this.queryForm.major_id = ''
                this.queryForm.plan_id = ''
                console.log('学校没有该专业，已清除专业填充')
              } else {
                console.log('使用院校ID搜索结果为空，退回到无院校ID搜索')
                searchWithoutCollege()
              }
            }
          })
          .catch(error => {
            this.pageLoading = false
            console.error('专业搜索失败:', error)
          })
      }

      const searchWithoutCollege = () => {
        const searchParams = {
          province_id: this.searchFormObj.province_id || 5604,
          dzs_cate_id: this.searchFormObj.dzs_cate_id || 7079,
          major_id: majorName,
          limit: 10,
          page: 1
        }

        console.log('不使用院校ID筛选专业')
        this.pageLoading = true
        commonApi.getQuestionEdusPlan(searchParams)
          .then(res => {
            this.pageLoading = false
            if (res.code == 200 && res.data.data.length > 0) {
              console.log('专业搜索结果:', res.data.data)

              let matchedMajor = null
              for (const item of res.data.data) {
                item.name = item.major.title
                if (item.name === majorName || item.name.includes(majorName) || majorName.includes(item.name)) {
                  matchedMajor = item
                  break
                }
              }

              if (!matchedMajor && res.data.data.length > 0) {
                matchedMajor = res.data.data[0]
                console.log('未找到精确匹配，使用第一个结果:', matchedMajor)
              }

              if (matchedMajor) {
                this.queryForm.major_id = matchedMajor.major_id
                this.queryForm.plan_id = matchedMajor.id
                if (!this.queryForm.college_id) {
                  this.queryForm.college_id = matchedMajor.college_id
                }
                console.log('专业数据已更新到表单:', {
                  major_id: matchedMajor.major_id,
                  plan_id: matchedMajor.id,
                  college_id: matchedMajor.college_id
                })
                this.getCollectSubjects()
              } else {
                console.log('未找到匹配的专业数据')
              }
            } else {
              console.log('专业搜索结果为空')
            }
          })
          .catch(error => {
            this.pageLoading = false
            console.error('专业搜索失败:', error)
          })
      }

      if (this.queryForm.college_id) {
        searchWithCollege()
      } else {
        searchWithoutCollege()
      }
    },

    provinceChange(e) {
      console.log('provinceChange', e)
      // this.searchFormObj.dzs_cate_id = "";
      commonApi.getQuestionEdus({ province_id: e }).then(res => {
        if (res.code == 200) {
          console.log('getQuestionEdus', res.data.data)
          this.attrOptions2 = res.data.data
        }
      })
    },
    // 通用-获取省份列表
    getAreaList() {
      commonApi.getAreaList()
        .then(res => {
          if (res.code === 200) {
            this.regionOptions = []
            this.regionOptions.push({ id: '0', name: '不限' })
            res.data.forEach(item => {
              this.regionOptions.push(item)
            })
            console.log('this.regionOptions', this.regionOptions)
          }
        })
        .catch(() => {
        })
    },
    majorChoose() {
      // 打开报考专业选择弹框
      this.searchFormObj.college_id = this.queryForm.college_id
      this.attr_id = []
      if (this.queryForm.attr_id) {
        this.attr_id.push(this.queryForm.attr_id)
      }
      this.getQuestionEdusPlan()
      this.majorVisible = true
    },
    getCollegeList() {
      commonApi.getCollegeNameList({}).then(res => {
        if (res.code === 200) {
          this.collegeOptions = res.data || []
          console.log('院校列表:', this.collegeOptions)
          this.collegeMap = res.data.reduce((acc, college) => {
            acc[college.title] = college.id
            return acc
          }, {})
        } else {
          console.error('获取院校列表失败:', res.msg)
        }
      }).catch(error => {
        console.error('getCollegeList API调用失败:', error)
      })
    },
    handleChange() {
      console.log('handleChange', this.area)
    },
    getAreas() {
      commonApi.getAllArea().then(res => {
        if (res.code === 200) {
          console.log('getAllArea', res.data)
          this.allAreaData = res.data
          this.areaRawData = this.areaList(res.data)
        }
      })
    },
    // 地域选项数据
    areaList(data) {
      const area = new Map()
      const size = area.size
      const map = new Map()
      const areaList = []
      data.forEach(item => {
        if (map.has(item.pid)) {
          const parent = map.get(item.pid)
          if (!parent.hasOwnProperty('children')) {
            parent.children = []
          }
          const child = {
            id: item.id,
            label: item.name,
            fullLabel: parent.fullLabel + '-' + item.name,
            raw: item,
            disabled:
              size > 0 &&
              !area.has(item.id) &&
              !area.has(item.pid) &&
              !map.has(item.pid)
          }
          parent.children.push(child)
          map.set(item.id, child)
        } else {
          const obj = {
            id: item.id,
            label: item.name,
            fullLabel: item.name,
            raw: item,
            disabled:
              size > 0 &&
              !area.has(item.id) &&
              !area.has(item.pid) &&
              !map.has(item.pid)
          }
          areaList.push(obj)
          map.set(item.id, obj)
        }
      })
      console.log('areaList', areaList)
      return areaList
    },
    confirm(){ 
      if (!this.queryForm.name) {
        this.$message.error('请先填写考生姓名!')
        return
      }
      if (!this.queryForm.attr_id && this.queryForm.custom_mode == 1) {
        this.$message.error('请先选择考生类别!')
        return
      }
      if (!this.queryForm.college_id && this.queryForm.custom_mode == 1) {
        this.$message.error('请先选择报考院校!')
        return
      }
      if (!this.queryForm.major_id && this.queryForm.custom_mode == 1) {
        this.$message.error('请先填写报考专业!')
        return
      }
      if (this.selectSubjects.length > 0) {
        this.queryForm.examoutline_id = this.selectSubjects.join(',')
      } else {
        this.$message.error('请先选择科目!')
        return
      }
      if (!this.queryForm.type) {
        this.$message.error('请先选择资料类别!')
        return
      }
      if (!this.queryForm.address_name) {
        this.$message.error('请先填写收件人姓名!')
        return
      }
      if (!this.queryForm.address_phone) {
        this.$message.error('请先填写手机号!')
        return
      }
      if (this.area.length > 0) {
        this.queryForm.area = this.area.toString()
      } else {
        this.$message.error('请先选择收件地址省市县!')
        return
      }
      if (!this.queryForm.address) {
        this.$message.error('请先填写详细街道地址!')
        return
      }
      if (!this.queryForm.order_from) {
        this.$message.error('请先选择订单来源!')
        return
      }
      if (!this.queryForm.mobile) {
        this.$message.error('请先填写用户手机号!')
        return
      } 
      this.saveLoading = true
      let postData = {
        id: this.tob_good_id,
        is_custom_order: 1,
        subject_num: this.selectSubjects.length
      }
      commonApi.getTobGoodInfo(postData)
        .then(res => {
          this.saveLoading = false
          if (res.code == 200) {
            this.goodInfo = res.data.good
            console.log('getTobGoodInfo', res.data)
              
            this.doubleConfirmVisible = true
          }
        }) 
    },
    keepTwoDecimal(num) {
        var result = parseFloat(num);
        if (isNaN(result)) {
            alert('传递参数错误，请检查！');
            return false;
        }
        result = Math.round(num * 100) / 100;
        return result;
    },
    saveFn() {
      console.log('saveFn', this.queryForm, this.area) 
      var postData = deepClone(this.queryForm) 
      const areaAll = []
      this.area.forEach(item => {
        areaAll.push(this.allAreaMap.get(item))
      })
      postData.address = areaAll.toString() + this.queryForm.address
      postData.uid = this.uid
      postData.good_id = this.good_id 
      console.log('saveFn', postData)
      commonApi.customOrderSave(postData)
        .then(res => { 
          this.doubleConfirmVisible = false
          this.successVisible = true
          if (res.code === 200) { 
            this.submissionType = true
            setTimeout(() => {
              this.$router.push({
                path: "/customOrderList", 
              });
            }, 1000);
          }else{ 
            this.submissionType = false 
            console.log("surplus_recharge_fee",Number(res.data.surplus_recharge_fee), Number(res.data.fee))
            if(Number(res.data.surplus_recharge_fee) < Number(res.data.fee)){ 
              this.czbtnShow = true
            }else{ 
              this.czbtnShow = false
            } 
          } 
        })
    },
    handleClose(done) {
      done()
    },
    // 快速填充相关方法
    getAddress() {
      this.addressQuickFillVisible = true
    },
    handleAddressQuickFillClose() {
      this.addressQuickFillVisible = false
      this.addressQuickFillForm.content = ''
    },
    confirmAddressQuickFill() {
      if (!this.addressQuickFillForm.content) {
        this.$message.warning('请输入要填充的内容')
        return
      }
      this.loading = true
      try {
        this.parseAddressContent(this.addressQuickFillForm.content)
        this.$message.success('填充成功')
        this.handleAddressQuickFillClose()
      } catch (error) {
        this.$message.error('填充失败：' + error.message)
      } finally {
        this.loading = false
      }
    },
    // 解析地址内容
    parseAddressContent(content) {
      // 按换行符拆分内容为多行
      const lines = content.split(/\n|\r\n/).filter(line => line.trim() !== '')

      // 用于存储解析结果
      const parsedData = {}
      console.log(parsedData)
      // 逐行解析
      lines.forEach((line, index) => {
        const trimmedLine = line.trim()
        console.log(`第${index + 1}行原始内容: ${line}`)
        console.log(`第${index + 1}行处理后: ${trimmedLine}`)

        // 解析姓名
        if (trimmedLine.match(/^(考生姓名|姓名|收货人|收件人|学生)[\s]*[:：][\s]*/)) {
          parsedData.name = trimmedLine.replace(/^(考生姓名|姓名|收货人|收件人|学生)[\s]*[:：][\s]*/, '').trim()
          console.log(`解析到姓名: ${parsedData.name}`)
        }
        // 解析电话
        else if (trimmedLine.match(/^(电话|手机号|手机号码|手机|联系电话|联系手机|电话号码|联系方式|联系电话)[\s]*[:：][\s]*/)) {
          const phoneMatch = trimmedLine.match(/1[3-9]\d{9}/)
          if (phoneMatch) {
            parsedData.phone = phoneMatch[0]
            console.log(`解析到电话: ${parsedData.phone}`)
          }
        }
        // 解析地址
        else if (trimmedLine.match(/^(地址|收件地址|收货地址|详细地址)[\s]*[:：][\s]*/)) {
          parsedData.address = trimmedLine.replace(/^(地址|收件地址|收货地址|详细地址)[\s]*[:：][\s]*/, '').trim()
          console.log(`解析到地址: ${parsedData.address}`)
        }
        // 解析高中/考生类别
        else if (trimmedLine.match(/^(高中|考生类别|普高\/中职)[\s]*[:：][\s]*/)) {
          parsedData.category = trimmedLine.replace(/^(高中|考生类别|普高\/中职)[\s]*[:：][\s]*/, '').trim()
          console.log(`解析到考生类别: ${parsedData.category}`)
        }
        // 解析有无意愿学校
        else if (trimmedLine.match(/^(学校|有无意愿学校|意愿学校|报考院校|目标院校)[\s]*[:：][\s]*/)) {
          parsedData.wishSchool = trimmedLine.replace(/^(学校|有无意愿学校|意愿学校|报考院校|目标院校)[\s]*[:：][\s]*/, '').trim()
          console.log(`解析到意愿学校: ${parsedData.wishSchool}`)
        }
        // 解析报考专业
        else if (trimmedLine.match(/^(专业|报考专业|意向专业|专业名称)[\s]*[:：][\s]*/)) {
          parsedData.major = trimmedLine.replace(/^(专业|报考专业|意向专业|专业名称)[\s]*[:：][\s]*/, '').trim()
          console.log(`解析到报考专业: ${parsedData.major}`)
        }
      })

      console.log("parsedData", parsedData)

      // 验证必填字段
      if (!parsedData.name) {
        throw new Error('未找到姓名')
      }
      if (!parsedData.phone) {
        throw new Error('未找到手机号')
      }
      if (!parsedData.address) {
        throw new Error('未找到地址')
      }

      // 填充到表单
      this.queryForm.address_name = parsedData.name
      this.queryForm.name = parsedData.name // 同时填充考生姓名
      this.queryForm.address_phone = parsedData.phone

      // 处理意愿学校（需要在专业搜索之前填充college_id）
      if (parsedData.wishSchool) {
        if (this.collegeMap && this.collegeMap[parsedData.wishSchool]) {
          this.queryForm.college_id = this.collegeMap[parsedData.wishSchool].toString()
        } else {
          const fuzzyMatches = this.collegeOptions.filter(college =>
            college.title.toLowerCase().includes(parsedData.wishSchool.toLowerCase())
          )
          if (fuzzyMatches.length > 0) {
            this.queryForm.college_id = fuzzyMatches[0].id.toString()
          }
        }
      }

      // 填充报考专业
      if (parsedData.major && this.queryForm.college_id) {
        this.queryForm.major_name = parsedData.major
        console.log('报考专业已填充到表单:', parsedData.major)

        // 搜索提取出来的专业，拿到对应的数据
        this.searchMajor(parsedData.major, true)
      }

      // 处理地址，尝试拆分省市区
      const address = parsedData.address
      console.log('原始地址:', address)

      // 定义更全面的省市区正则表达式
      const provinceRegex = /(北京市|上海市|天津市|重庆市|河北省|山西省|辽宁省|吉林省|黑龙江省|江苏省|浙江省|安徽省|福建省|江西省|山东省|河南省|湖北省|湖南省|广东省|海南省|四川省|贵州省|云南省|陕西省|甘肃省|青海省|台湾省|内蒙古自治区|广西壮族自治区|西藏自治区|宁夏回族自治区|新疆维吾尔自治区|香港特别行政区|澳门特别行政区)/;
      const cityRegex = /^(.*?[市州地区盟])/;
      const districtRegex = /(.+?[区县市旗自治县自治旗特区林区])/;
      
      // 尝试解析省市区
      let province = ''
      let city = ''
      let district = ''
      let detailAddress = ''
      let remainingAddress = address

      // 第一步：匹配省份
      const provinceMatch = remainingAddress.match(provinceRegex)
      if (provinceMatch) {
        province = provinceMatch[0]
        remainingAddress = remainingAddress.substring(province.length).trim()
        console.log('匹配到省份:', province, '剩余地址:', remainingAddress)
      }

      // 第二步：先匹配城市
      if (remainingAddress) {
        const cityMatch = remainingAddress.match(cityRegex)
        if (cityMatch) {
          city = cityMatch[1]
          remainingAddress = remainingAddress.substring(city.length).trim()
          console.log('匹配到城市:', city, '剩余地址:', remainingAddress)

          // 第三步：城市匹配后再尝试匹配区县
          if (remainingAddress) {
            const districtMatch = remainingAddress.match(districtRegex)
            if (districtMatch) {
              district = districtMatch[1]
              remainingAddress = remainingAddress.substring(district.length).trim()
              console.log('匹配到区县:', district, '剩余地址:', remainingAddress)
            }
          }
        } 
        // else {
        //   // 第四步：如果没有匹配到城市，再尝试匹配区县
        //   const districtMatch = remainingAddress.match(districtRegex);
        //   if (districtMatch) {
        //     district = districtMatch[1];
        //     remainingAddress = remainingAddress.substring(district.length).trim();
        //     console.log('匹配到区县:', district, '剩余地址:', remainingAddress);
        //   }
        // }
      } else {
        // 如果没有剩余地址，可能只有省名
        console.log('解析后只有省份:', province)
      }

      // 剩余部分作为详细地址
      detailAddress = remainingAddress
      console.log('详细地址:', detailAddress)

      // 如果没有匹配到省份，尝试使用更简单的方式匹配
      if (!province) {
        console.log('未匹配到完整省份，尝试使用更简单的方式')
        // 尝试匹配包含'省'的省份
        const simpleProvinceRegex = /(.+?省)/
        const simpleProvinceMatch = address.match(simpleProvinceRegex)
        if (simpleProvinceMatch) {
          province = simpleProvinceMatch[1]
          console.log('简单匹配到省份:', province)
        }
      }

      // 处理地址选择器（area）和详细地址
      if (province || city || district) {
        // 尝试匹配地址ID
        const fullAreaName = province + city + district
        this.queryForm.address = detailAddress

        // 尝试从areaRawData中匹配地址ID
        this.findAreaIds(province, city, district)
      } else {
        this.queryForm.address = address
      }

      // 处理考生类别
      if (parsedData.category) {
        const categoryMap = {
          '应届普高生': ['应届普高', '应届高中', '普高应届', '高中应届'],
          '中职生': ['中职', '中等职业', '职业高中', '职高'],
          '往届生': ['往届', '往届高中', '高中往届'],
          '退役士兵': ['退役士兵', '士兵退役', '退伍士兵', '士兵退伍'],
          '社会考生': ['社会考生', '社会生', '社会报名'],
          '艺体特长生': ['艺体特长', '艺术特长', '体育特长', '艺体生'],
          '其他': ['其他', '其他考生']
        }

        // 遍历所有可能的类别进行模糊匹配
        let matchedCategory = null
        for (const [category, keywords] of Object.entries(categoryMap)) {
          for (const keyword of keywords) {
            if (parsedData.category.includes(keyword)) {
              matchedCategory = category
              break
            }
          }
          if (matchedCategory) break
        }

        // 如果匹配到类别，查找对应的attr_id
        if (matchedCategory && this.attrOptions.length > 0) {
          const categoryItem = this.attrOptions.find(item => item.value.includes(matchedCategory))
          if (categoryItem) {
            this.queryForm.attr_id = categoryItem.key
          }
        }
      }
    },
    // 查找地址ID
    findAreaIds(province, city, district) {
      // 重置area
      this.area = []

      if (!province) return

      console.log('开始查找地址ID:', { province, city, district })
      console.log('areaRawData:', this.areaRawData)

      // 查找省份ID - 使用更精确的匹配
      let provinceNode = null
      for (const item of this.areaRawData) {
        console.log('省份匹配:', item.label, '与', province)
        if (item.label === province || item.label.includes(province)) {
          provinceNode = item
          this.area.push(item.id)
          console.log('找到省份:', item.label, 'ID:', item.id)
          break
        }
      }

      // 如果在areaRawData中找不到省份，尝试直接从allAreaData中查找
      if (!provinceNode) {
        console.log('在areaRawData中未找到省份，尝试从allAreaData中查找')
        const provinceItem = this.allAreaData.find(item =>
          item.name === province && item.pid === 0
        )
        if (provinceItem) {
          this.area.push(provinceItem.id)
          console.log('从allAreaData找到省份:', provinceItem.name, 'ID:', provinceItem.id)

          // 尝试查找城市
          if (city) {
            const cityItem = this.allAreaData.find(item =>
              item.pid === provinceItem.id && (item.name === city || item.name.includes(city))
            )

            // 处理城市匹配结果
            if (cityItem) {
              this.area.push(cityItem.id)
              console.log('从allAreaData找到城市:', cityItem.name, 'ID:', cityItem.id)

              // 尝试查找区县
              if (district) {
                const districtItem = this.allAreaData.find(item =>
                  item.pid === cityItem.id && (item.name === district || item.name.includes(district))
                )
                if (districtItem) {
                  this.area.push(districtItem.id)
                  console.log('从allAreaData找到区县:', districtItem.name, 'ID:', districtItem.id)
                }
              }
            } else {
              console.log('从allAreaData城市匹配失败，尝试将city作为district查找:', city)
              let foundCityItem = null
              let foundDistrictItem = null

              // 查找所有城市
              const cities = this.allAreaData.filter(item => item.pid === provinceItem.id)

              // 先尝试将city作为district查找
              for (const cityItem of cities) {
                const districtItem = this.allAreaData.find(item =>
                  item.pid === cityItem.id && (item.name === city || item.name.includes(city))
                )

                if (districtItem) {
                  foundCityItem = cityItem
                  foundDistrictItem = districtItem
                  break
                }
              }

              // 如果找到，添加到area数组
              if (foundCityItem && foundDistrictItem) {
                this.area.push(foundCityItem.id)
                this.area.push(foundDistrictItem.id)
                console.log('从allAreaData根据city作为区县找到城市:', foundCityItem.name, 'ID:', foundCityItem.id)
                console.log('从allAreaData找到区县:', foundDistrictItem.name, 'ID:', foundDistrictItem.id)

                // 如果有原始的district内容，将其添加到详细地址前面
                if (district) {
                  console.log('将原始district内容添加到详细地址前面:', district)
                  this.queryForm.address = district + (this.queryForm.address ? ' ' + this.queryForm.address : '')
                }

                // 标记已经找到区县，避免后续重复查找
                district = ''
              }
              // 如果没有找到，且有district参数，再尝试根据district查找城市
              else if (district) {
                console.log('从allAreaData根据city作为区县未找到，尝试根据district查找城市:', district)
                for (const cityItem of cities) {
                  const districtItem = this.allAreaData.find(item =>
                    item.pid === cityItem.id && (item.name === district || item.name.includes(district))
                  )

                  if (districtItem) {
                    foundCityItem = cityItem
                    foundDistrictItem = districtItem
                    break
                  }
                }

                if (foundCityItem && foundDistrictItem) {
                  this.area.push(foundCityItem.id)
                  this.area.push(foundDistrictItem.id)
                  console.log('从allAreaData根据district找到城市:', foundCityItem.name, 'ID:', foundCityItem.id)
                  console.log('从allAreaData找到区县:', foundDistrictItem.name, 'ID:', foundDistrictItem.id)
                }
              }
            }
          }
          console.log('最终area数组:', this.area)
          return
        }
      }

      if (!provinceNode || !provinceNode.children) return

      let cityNode = null
      // 如果有city参数，先尝试直接匹配城市
      if (city) {
        for (const item of provinceNode.children) {
          console.log('城市匹配:', item.label, '与', city)
          if (item.label === city || item.label.includes(city)) {
            cityNode = item
            this.area.push(item.id)
            console.log('找到城市:', item.label, 'ID:', item.id)
            break
          }
        }

        // 如果没有找到城市，但有city参数，尝试将city作为district查找
        if (!cityNode) {
          console.log('城市匹配失败，尝试将city作为district查找:', city)
          let foundCityNode = null
          let foundDistrictNode = null

          for (const cityItem of provinceNode.children) {
            if (cityItem.children) {
              for (const districtItem of cityItem.children) {
                if (districtItem.label === city || districtItem.label.includes(city)) {
                  foundCityNode = cityItem
                  foundDistrictNode = districtItem
                  break
                }
              }
            }
            if (foundCityNode) break
          }

          if (foundCityNode && foundDistrictNode) {
            cityNode = foundCityNode
            this.area.push(foundCityNode.id)
            this.area.push(foundDistrictNode.id)
            console.log('根据city作为区县找到城市:', foundCityNode.label, 'ID:', foundCityNode.id)
            console.log('找到区县:', foundDistrictNode.label, 'ID:', foundDistrictNode.id)

            // 如果有原始的district内容，将其添加到详细地址前面
            if (district) {
              console.log('将原始district内容添加到详细地址前面:', district)
              this.queryForm.address = district + (this.queryForm.address ? ' ' + this.queryForm.address : '')
            }

            // 标记已经找到区县，避免后续重复查找
            district = ''
          }
        }
      }

      // 如果有district参数
      if (district) {
        // 如果找到城市节点，直接在其下查找区县
        if (cityNode && cityNode.children) {
          for (const item of cityNode.children) {
            console.log('区县匹配:', item.label, '与', district)
            if (item.label === district || item.label.includes(district)) {
              this.area.push(item.id)
              console.log('找到区县:', item.label, 'ID:', item.id)
              break
            }
          }
        } else {
          // 如果没有找到城市节点，遍历该省份下所有城市查找包含该区县的城市
          console.log('没有找到城市，尝试根据区县名称在该省份下所有城市中查找')
          let foundCityNode = null
          let foundDistrictNode = null

          for (const cityItem of provinceNode.children) {
            if (cityItem.children) {
              for (const districtItem of cityItem.children) {
                if (districtItem.label === district || districtItem.label.includes(district)) {
                  foundCityNode = cityItem
                  foundDistrictNode = districtItem
                  break
                }
              }
            }
            if (foundCityNode) break
          }

          if (foundCityNode && foundDistrictNode) {
            this.area.push(foundCityNode.id)
            this.area.push(foundDistrictNode.id)
            console.log('根据区县找到城市:', foundCityNode.label, 'ID:', foundCityNode.id)
            console.log('找到区县:', foundDistrictNode.label, 'ID:', foundDistrictNode.id)
          }
        }
      }

      console.log('最终area数组:', this.area)
    }  
  },
};
</script>

<style lang="less" scoped> 
.basicStyle {
  overflow: auto;
  h1 {
    margin: 10px 0 20px 0;
  }
  /deep/ .el-input,
  .el-textarea {
    width: 300px;
  }
  .dialog-footer {
    text-align: center;
    margin: 20px 0;
  }
  .notice {
    font-size: 12px;
    color: #846ffd;
    margin-left: 200px;
  }
}
.checkCool {
  margin-bottom: 15px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.checkCool2 {
  margin-bottom: 15px;
  font-size: 14px;
  color: #606061;
  cursor: pointer;
}

h4 {
  margin-bottom: 15px;
  line-height: 30px;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #846ffd;
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
}

.popoverClass {
  padding-top: 10px;
  margin-right: 50px;
  p {
    text-align: center;
  }
  /deep/ .el-button {
    border: none;
    padding: 0;
    background: none;
  }
  /deep/ .el-button:focus,
  .el-button:hover {
    background: none;
  }
  img {
    width: 20px;
    height: 20px;
    // margin: 0 50px 0 10px;
    margin-left: 10px;
  }
}
.extraItem {
  margin-left: 0;
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
/deep/.extraDiv {
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
/deep/.el-popover p {
  text-align: left;
  width: 300px;
  padding: 0 10px;
}
/deep/.avatar-uploader2 .el-upload {
  width: 88px !important;
  height: 88px !important;
  align-items: center;
  display: flex;
  justify-content: center;
  border: 1px solid #ddd;
  border-radius: 5px;
}
/deep/.avatar-uploader2 img {
  width: 88px !important;
  height: 88px !important;
  line-height: 88px;
}
.checkCool {
}
.bg_box {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
} 

  /deep/ .inline-form-item {
    display: inline-block;
    margin: 0;
    vertical-align: middle;
  }
  /deep/ .el-form-item {
    margin-bottom: 0;
    line-height: 28px;
    width: calc(100% - 160px);
  }
  /deep/ .star {
    color: red;
    margin-right: 4px;
    font-size: 20px;
  }
  /deep/ .filter-item{
      margin-bottom: 10px;
      display: flex;
      .classLabel{
        text-align: right;
        width: 150px;
      }
    }
  /deep/.title {
      font-size: 16px;
      font-weight: 700;
      padding: 10px 10px 20px 55px; 
      border-top: 10px solid #f4f4f4;
  }
  /deep/.title:first-child {
    border-top: none;
  }
  
  /deep/ .inline-form-item {
    display: inline-block;
    margin: 0;
    vertical-align: middle;
  }
  /deep/ .el-form-item {
    margin-bottom: 0;
    line-height: 28px;
    width: calc(100% - 160px);
  }
  /deep/ .star {
    color: red;
    margin-right: 4px;
    font-size: 20px;
  }
  /deep/ .filter-item{
      margin-bottom: 10px;
      display: flex;
      .classLabel{
        text-align: right;
      }
    }

  /deep/ .userProfile{
    background: #fdf2e0;
    padding: 5px;
    margin-top: 10px;
    width: 300px;
  }

  /deep/.box-card .inline-form-item{
    width: auto;
    display: inline-block;
    margin: 0;
    vertical-align: middle;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  /deep/.doubleTitle{
    color:red;
    font-size:14px;
    text-align: center;
  }
  /deep/.doubleCont{
    color:#846FFD;
    font-size:14px;
    text-align: center;
    margin-top: 20px;
  }
  
/deep/.RechargeBox {
  background: #ffffff;
  border-radius: 8px;
  padding-bottom: 40px;
  .rightH2Top {
    padding: 0 0 0 105px;
    // padding-bottom: 25px;
    // border-bottom: 1px solid #ddd;
    .rightH2a {
      line-height: 180%;
      font-size: 18px;
      color: #465069;
    }
  }
  .rightH2Bottom {
    // padding-top: 10px;
    margin-top: 25px;
    .rightH2b {
      width: 132px;
      padding: 14px 13px;
      line-height: 140%;
      padding-bottom: 10px;
      text-align: center;
      background: #f7f8fb;
      border-radius: 8px;
      display: block;
      margin: 0 auto;
      font-size: 15px;
      color: #6d7181;
    }
  }
}

/deep/.successTitle{
    color:#000;
    font-size:14px;
    text-align: center;
  
}
/deep/.successCont1{
    color:red;
    font-size:14px;
    text-align: center;

}
/deep/.successCont2{
    color:#000;
    font-size:14px;
    text-align: center; 
}
/deep/.successCont3{
    text-align: center;
    margin-top: 20px;
    .el-button{
      border: 1px solid #9583ff;
      border-radius: 3px;
      color: #9583ff;
      padding: 14px 20px;
    }
} 
</style>
